import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useContents } from "../Footer.hook";
import { fields } from "../constants";

export const AddEditContent = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useContents(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      content_title_en: decodeHTML(
        dataById ? dataById.payload.content_title_en : editData ? editData?.[0]?.content_title_en : ""
      ),
      content_title_ms: decodeHTML(
        dataById ? dataById.payload.content_title_ms : editData ? editData?.[0]?.content_title_ms : ""
      ),
      content_title_zh: decodeHTML(
        dataById ? dataById.payload.content_title_zh : editData ? editData?.[0]?.content_title_zh : ""
      ),

      field_welcome_note_en: decodeHTML(
        dataById ? dataById.payload.field_welcome_note_en : editData ? editData?.[0]?.field_welcome_note_en : ""
      ),
      field_welcome_note_ms: decodeHTML(
        dataById ? dataById.payload.field_welcome_note_ms : editData ? editData?.[0]?.field_welcome_note_ms : ""
      ),
      field_welcome_note_zh: decodeHTML(
        dataById ? dataById.payload.field_welcome_note_zh : editData ? editData?.[0]?.field_welcome_note_zh : ""
      ),
      field_welcome_note_url: decodeHTML(
        dataById ? dataById.payload.field_welcome_note_url : editData ? editData?.[0]?.field_welcome_note_url : ""
      ),

      field_awards_en: decodeHTML(
        dataById ? dataById.payload.field_awards_en : editData ? editData?.[0]?.field_awards_en : ""
      ),
      field_awards_ms: decodeHTML(
        dataById ? dataById.payload.field_awards_ms : editData ? editData?.[0]?.field_awards_ms : ""
      ),
      field_awards_zh: decodeHTML(
        dataById ? dataById.payload.field_awards_zh : editData ? editData?.[0]?.field_awards_zh : ""
      ),
      field_awards_url: decodeHTML(
        dataById ? dataById.payload.field_awards_url : editData ? editData?.[0]?.field_awards_url : ""
      ),

      field_about_us_en: decodeHTML(
        dataById ? dataById.payload.field_about_us_en : editData ? editData?.[0]?.field_about_us_en : ""
      ),
      field_about_us_ms: decodeHTML(
        dataById ? dataById.payload.field_about_us_ms : editData ? editData?.[0]?.field_about_us_ms : ""
      ),
      field_about_us_zh: decodeHTML(
        dataById ? dataById.payload.field_about_us_zh : editData ? editData?.[0]?.field_about_us_zh : ""
      ),
      field_about_us_url: decodeHTML(
        dataById ? dataById.payload.field_about_us_url : editData ? editData?.[0]?.field_about_us_url : ""
      ),

      field_news_en: decodeHTML(
        dataById ? dataById.payload.field_news_en : editData ? editData?.[0]?.field_news_en : ""
      ),
      field_news_ms: decodeHTML(
        dataById ? dataById.payload.field_news_ms : editData ? editData?.[0]?.field_news_ms : ""
      ),
      field_news_zh: decodeHTML(
        dataById ? dataById.payload.field_news_zh : editData ? editData?.[0]?.field_news_zh : ""
      ),
      field_news_url: decodeHTML(
        dataById ? dataById.payload.field_news_url : editData ? editData?.[0]?.field_news_url : ""
      ),

      field_contact_us_en: decodeHTML(
        dataById ? dataById.payload.field_contact_us_en : editData ? editData?.[0]?.field_contact_us_en : ""
      ),
      field_contact_us_ms: decodeHTML(
        dataById ? dataById.payload.field_contact_us_ms : editData ? editData?.[0]?.field_contact_us_ms : ""
      ),
      field_contact_us_zh: decodeHTML(
        dataById ? dataById.payload.field_contact_us_zh : editData ? editData?.[0]?.field_contact_us_zh : ""
      ),
      field_contact_us_url: decodeHTML(
        dataById ? dataById.payload.field_contact_us_url : editData ? editData?.[0]?.field_contact_us_url : ""
      ),

      field_career_en: decodeHTML(
        dataById ? dataById.payload.field_career_en : editData ? editData?.[0]?.field_career_en : ""
      ),
      field_career_ms: decodeHTML(
        dataById ? dataById.payload.field_career_ms : editData ? editData?.[0]?.field_career_ms : ""
      ),
      field_career_zh: decodeHTML(
        dataById ? dataById.payload.field_career_zh : editData ? editData?.[0]?.field_career_zh : ""
      ),
      field_career_url: decodeHTML(
        dataById ? dataById.payload.field_career_url : editData ? editData?.[0]?.field_career_url : ""
      ),
    },
    fields: fields.contents,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else {
          data[key] = ""; // fallback in case of invalid field
        }
      } catch (error) {
        console.error("Image processing failed for:", key, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Footer",
      subModule: `contents`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.id || dataById?.payload?.id }),
        name: data?.content_title_en,
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      console.log("payload", payload);
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Contents`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") || query.get("type") === "update"}`
              ? `${eramanHost}/api/get-footer-content-taxonomy-list-crud-api-data/${editData?.[0]?.id || dataById?.payload?.id}`
              : `${eramanHost}/api/create-footer-content-taxonomy-list-crud-api-data`,
            `${query.get("editId") || query.get("type") === "update" ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") || query.get("type") === "update" ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
